// Base URL of the Cloudflare R2 bucket hosting the page data (home.json, about.json)
export const DATA_BASE_URL = "https://pub-ffd4c6aa53ed4ac29e54117bcf54cc58.r2.dev/data";
